import React from 'react';

import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import { FormGroup, Label } from 'reactstrap';
import { ButtonWithLoadingIcon } from '../../../common/ButtonWithLoadingIcon';
import { Colxx } from '../../../common/CustomBootstrap';
import {
  CommonFormInput,
  SelectFormInput,
} from '../../../common/CustomFormComponents';
import { genders } from './choiceOptions';
import { useUserContext } from '../../../../context/UserContext';
import './aboutMeEdit.scss';
// components

// end of components

const profileEditSchema = Yup.object().shape({
  // username: Yup.string().required('Please enter username').nullable(),
  // usually_wears: Yup.object({
  //   size: Yup.string().required('Please select size'),
  //   ussize: Yup.number().required('Please select u.s. size'),
  //   denim: Yup.number().required('Please select denim size'),
  // }),
  // body_type: Yup.string().required('Please select body type'),
  // bra_size: Yup.object({
  //   band: Yup.string().required('Please select band size'),
  //   cup: Yup.string().required('Please select cup size'),
  // }),
  // age: Yup.number().required('Please enter your age').nullable(),
  age_error: Yup.number().when('age', {
    is: (age) => age < 13 || age > 100,
    then: Yup.number().required('Age must be above 13 or below 100'),
  }),
  // height: Yup.object({
  //   feet: Yup.string().required('Please select feet').nullable(),
  //   inch: Yup.string().required('Please select inches').nullable(),
  // }),
  // weight: Yup.number().required('Please enter the weight').nullable(),
  weight_error: Yup.number().when('weight', {
    is: (weight) => weight < 70 || weight > 900,
    then: Yup.number().required('Weight must be above 70 or below 900'),
  }),
  // gender: Yup.string().required('Please enter your gender').nullable(),
});

export const AboutMeEdit = ({
  aboutMeData,
  isUpdating,
  onSubmit,
  selectedUsuallyWears,
  selectedBraSize,
  selectedHeight,
}) => {
  const { braSize, usuallyWears, bodyTypes, heightData } = useUserContext();
  const initialValues = {
    username: aboutMeData.username || '',
    usually_wears: {
      size: selectedUsuallyWears?.size || '',
      ussize: selectedUsuallyWears?.ussize || '',
      denim: selectedUsuallyWears?.denim || '',
    },
    body_type: aboutMeData.body_type || '',
    bra_size: {
      band: selectedBraSize?.band || '',
      cup: selectedBraSize?.cup || '',
    },
    age: aboutMeData.age || '',
    height: {
      feet: selectedHeight?.feet || '',
      inch: selectedHeight?.inch || '',
    },
    weight: aboutMeData.weight || '',
    gender: aboutMeData.gender || '',
    year: aboutMeData.year || '',
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={profileEditSchema}
    >
      {({
        values,
        errors,
        isSubmitting,
        touched,
        setFieldValue,
        setFieldTouched,
      }) => {
        return (
          <Form className='mb-4'>
            <FormGroup row>
              <Colxx sm={12}>
                <CommonFormInput
                  label='Username'
                  name='username'
                  id='username'
                  showError={errors.username && touched.username}
                  error={errors.username}
                />
              </Colxx>

              <Colxx sm={12}>
                <SelectFormInput
                  label='Usually wears'
                  name='usually_wears.size'
                  id='usually_wears_size'
                  options={usuallyWears.filter((u) => u.type === 'size')}
                  showError={
                    errors?.usually_wears?.size && touched?.usually_wears?.size
                  }
                  error={errors?.usually_wears?.size}
                  showEmpty
                  selectTitle={'Select size'}
                />
                <SelectFormInput
                  name='usually_wears.ussize'
                  id='usually_wears_ussize'
                  options={usuallyWears.filter((u) => u.type === 'ussize')}
                  showError={
                    errors?.usually_wears?.ussize &&
                    touched?.usually_wears?.ussize
                  }
                  error={errors?.usually_wears?.ussize}
                  showEmpty
                  selectTitle={'Select U.S. size'}
                />
                <SelectFormInput
                  name='usually_wears.denim'
                  id='usually_wears.denim'
                  options={usuallyWears.filter((u) => u.type === 'denim')}
                  showError={
                    errors?.usually_wears?.denim &&
                    touched?.usually_wears?.denim
                  }
                  error={errors?.usually_wears?.denim}
                  showEmpty
                  selectTitle={'Select denim size'}
                />
              </Colxx>

              <Colxx sm={12}>
                <SelectFormInput
                  label='Body Type'
                  name='body_type'
                  id='profile-body_type'
                  options={bodyTypes}
                  showError={errors.body_type && touched.body_type}
                  error={errors.body_type}
                  showEmpty
                  selectTitle={'Select body type'}
                />
              </Colxx>

              <Label
                className={'label-text'}
                style={{ paddingLeft: 15, paddingRight: 15 }}
              >
                Bra size
              </Label>
              <div style={{ display: 'flex', width: '100%' }}>
                <Colxx sm={6}>
                  <SelectFormInput
                    name='bra_size.band'
                    id='profile-bra_size'
                    options={braSize?.filter((b) => b.type === 'band')}
                    showError={
                      errors?.bra_size?.band && touched?.bra_size?.band
                    }
                    error={errors?.bra_size?.band}
                    showEmpty
                    selectTitle={'Select band size'}
                  />
                </Colxx>
                <Colxx sm={6}>
                  <SelectFormInput
                    name='bra_size.cup'
                    id='profile-bra_cup_size'
                    options={braSize?.filter((b) => b.type === 'cup')}
                    showError={errors?.bra_size?.cup && touched?.bra_size?.cup}
                    error={errors?.bra_size?.cup}
                    showEmpty
                    selectTitle={'Select cup size'}
                  />
                </Colxx>
              </div>

              <Colxx sm={12}>
                <CommonFormInput
                  label='Age'
                  type='number'
                  name='age'
                  id='ship-age'
                  showError={
                    (errors.age || errors.age_error) &&
                    (touched.age || touched.age_error)
                  }
                  error={errors.age || errors.age_error}
                />
              </Colxx>

              <Label
                className={'label-text'}
                style={{ paddingLeft: 15, paddingRight: 15 }}
              >
                Height
              </Label>
              <div style={{ display: 'flex', width: '100%' }}>
                <Colxx sm={6}>
                  <SelectFormInput
                    name='height.feet'
                    id='ship-height'
                    options={heightData?.filter((b) => b.type === 'feet')}
                    showError={errors?.height?.feet && touched?.height?.feet}
                    error={errors?.height?.feet}
                    showEmpty
                    selectTitle={'Select feet'}
                  />
                </Colxx>
                <Colxx sm={6}>
                  <SelectFormInput
                    name='height.inch'
                    id='ship-height-inches'
                    options={heightData?.filter((b) => b.type === 'inch')}
                    showError={errors?.height?.inch && touched?.height?.inch}
                    error={errors?.height?.inch}
                    showEmpty
                    selectTitle={'Select inches'}
                  />
                </Colxx>
              </div>

              <Colxx sm={12}>
                <CommonFormInput
                  label='Weight'
                  type='number'
                  name='weight'
                  id='ship-weight'
                  showError={
                    (errors.weight || errors.weight_error) &&
                    (touched.weight || touched.weight_error)
                  }
                  error={errors.weight || errors.weight_error}
                />
              </Colxx>

              {/* <Colxx sm={12}>
                <SelectFormInput
                  label='Gender'
                  name='gender'
                  id='profile-gender'
                  options={genders}
                  showError={errors.gender && touched.gender}
                  error={errors.gender}
                  showEmpty
                />
              </Colxx> */}
            </FormGroup>

            <FormGroup row>
              <Colxx sm={12} className='d-flex justify-content-center'>
                <ButtonWithLoadingIcon
                  disabled={isUpdating}
                  type='submit'
                  loading={isUpdating}
                  color='primary'
                  size='md'
                  height={36}
                  className={'px-5'}
                >
                  UPDATE
                </ButtonWithLoadingIcon>
              </Colxx>
            </FormGroup>
          </Form>
        );
      }}
    </Formik>
  );
};
